import script from "./careerBody.vue?vue&type=script&setup=true&lang=js"
export * from "./careerBody.vue?vue&type=script&setup=true&lang=js"

import "./careerBody.vue?vue&type=style&index=0&id=12df020a&lang=scss"

const __exports__ = script;

export default __exports__